import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  IsBoolean,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2LarkImageTableResponse {
  code: number;
  msg: string;
  data: LarkImageTableData;
};
export interface LarkImageTableData {
  has_more: boolean;
  page_token?: string;
  total: number;
  items: Array<LarkImageTableItems>;
};
export interface LarkImageTableItems {
  record_id: string;
  fields: LarkImageTableItemFields;
};
export interface LarkImageTableItemFields {
  fileurl: string;
  remark?: string;
  status: string;
  styleId: string;
  sub_tem: string;
  template_cover: Array<TemplateCover>;
  template_id: string;
  template_name: string;
  template_type: string;
};
export interface TemplateCover {
  file_token: string;
  name: string;
  size: number;
  tmp_url: string;
  type: string;
  url: string;
};

// 请求接口
export interface AgentV2LarkImageTableRequest {
  pageToken: string,
  pageSize: string,
  templateId?: string,
  agentId?: string,
}

// * 重点取值对象
export class LarkImageTableItemFieldsData {
  @Required("File URL cannot be empty")
  @IsString("File URL must be a string")
  fileurl: string;

  @Required("Template ID cannot be empty")
  @IsString("Template ID must be a string")
  templateId: string;

  @Required("Template name cannot be empty")
  @IsString("Template name must be a string")
  templateName: string;
}

export class LarkImageTableItemsData {
  // @Required("Record ID cannot be empty")
  @IsString("Record ID must be a string")
  recordId: string;

  @Required("Fields cannot be empty")
  @ValidateNested(LarkImageTableItemFieldsData)
  fields: LarkImageTableItemFieldsData;

  @IsNumber("Template resource must be a number")
  templateResource: number;
}

export class AgentV2LarkImageTableData {
  // @Required("Has more cannot be empty")
  @IsBoolean("Has more must be a boolean")
  hasMore: boolean;

  // @Required("Page token cannot be empty")
  @IsString("Page token must be a string")
  pageToken: string;

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Items cannot be empty")
  @IsArray("Items must be an array")
  items: Array<LarkImageTableItemsData>;
}

class AgentV2LarkImageTableResponseData {
  // @Required("Code cannot be empty")
  @IsNumber("Code must be a number")
  code: number;

  // @Required("Msg cannot be empty")
  @IsString("Msg must be a string")
  msg: string;

  @Required("Data cannot be empty")
  @ValidateNested(AgentV2LarkImageTableData)
  data: AgentV2LarkImageTableData;
}

const transformAndValidateAgent = (
  response: AgentV2LarkImageTableResponse
): AgentV2LarkImageTableResponseData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentV2LarkImageTableResponseData);
  } catch (error) {
    console.error("Agent V2 Lark Image Table data validation failed:", error.message);
    throw error;
  }
};

/** 飞书图文模版 */
export const agentV2LarkImageTableData = async ({
  pageToken,
  pageSize,
  templateId,
  agentId,
}: AgentV2LarkImageTableRequest): Promise<AgentV2LarkImageTableResponseData> => {
  const response = await api.post<AgentV2LarkImageTableResponse>('/agent-v2/feishu-tuwen-table-data', {
    page_token: pageToken,
    page_size: pageSize,
    template_id: templateId,
    agent_id: agentId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
